import {
  Button,
  MenuItem,
  Modal,
  TextField,
  InputAdornment,
  Autocomplete,
} from "@mui/material";
import Agriculture from "@mui/icons-material/Agriculture";
import { createContext, useContext, useMemo, useState, useEffect } from "react";
import { ValTextAndNumber } from "../../../../../Validators/ValTextAndNumber";
import { ValOnlyNumber } from "../../../../../Validators/ValOnlyNumber";
import { FormatMoney } from "../../../../../Helpers/FormatNumber";
import { ValPedidoUnidades } from "./Validators/ValPedidoUnidades";
import request from "../../../../../Helpers/API";
import Swal from "sweetalert2";
import { Context as PedidoContext } from "./DashPedidoMaquinariascreen";
import { useHistory } from "react-router-dom";
import CreateIcon from "@mui/icons-material/Create";
import VerticalSplitIcon from "@mui/icons-material/VerticalSplit";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ArticleIcon from "@mui/icons-material/Article";
import { Moneda } from "../../../../../Helpers/Moneda";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { LoaderScreen } from "../../../../components/LoaderScreen";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";

const Context = createContext();

export default function DashPedidoMaquinariaUnidadesVendidas({
  screen,
  setScreen,
  value,
  setValue,
  setBottonguardar,
}) {
  const folio = useContext(PedidoContext);
  const history = useHistory();
  const [stateVendidas, setStateVendidas] = useState({
    open: false,
    folio: folio.state.folio,
    registro: -1,
    data: [],
  });
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const contextValue = useMemo(
    () => ({
      state: stateVendidas,
      setState: setStateVendidas,
    }),
    [stateVendidas, setStateVendidas]
  );
  const openModal = (registro) => {
    setStateVendidas({
      ...stateVendidas,
      open: true,
      registro,
    });
  };
  useEffect(() => {
    if (
      folio.state.folio === undefined ||
      folio.state.folio === null ||
      folio.state.folio.length != 13
    ) {
      history.push("/DashClientes/solicitudcreditoGenerar");
      return;
    }

    if (
      folio.state.folio !== undefined &&
      folio.state.folio.length === 13 &&
      Number(screen) >= 1
    ) {
      setBottonguardar(
        <div
          className="pedido-maquinaria-container-footer-guardar"
          onClick={() => Number(screen) >= 1 && setValue(2)}
        >
          Siguiente <ArrowForwardIcon />
        </div>
      );
    }

    setLoader({ ...loader, mostrar: true });
    request
      .get(`PedidoUnidades/Listado?folio=${folio.state.folio}`)
      .then((result) => {
        setStateVendidas({
          ...stateVendidas,
          data: result,
        });
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
      });
  }, [stateVendidas.open]);
  const EliminarRegistro = (item) => {
    Swal.fire({
      title: "Deseas eliminar el registro?",
      showDenyButton: true,
      showCancelButton: true,
      showConfirmButton: false,
      confirmButtonText: "Save",
      cancelButtonText: "Cancelar",
      denyButtonText: `Eliminar`,
    }).then((result) => {
      if (result.isDenied) {
        setLoader({ ...loader, mostrar: true });
        request
          .get(
            `PedidoUnidades/Delete?folio=${item.folio}&registro=${Number(
              item.registro
            )}`
          )
          .then((result) => {
            setStateVendidas({
              ...stateVendidas,
              data: result,
            });
            setLoader({ ...loader, mostrar: false });
          })
          .catch((error) => {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
          });
      }
    });
  };
  return (
    <Context.Provider value={contextValue}>
      <div className="pedido-maquinaria-unidades-container">
        <LoaderScreen loader={loader} />
        <Button
          onClick={() => openModal(-1)}
          fullWidth
          variant="contained"
          className="pedido-maquinaria-unidades-button-add"
        >
          <AddCircleIcon /> Agregar
        </Button>
        <ModalAgregar
          screen={screen}
          setScreen={setScreen}
          tipodesolicitud={folio.state.tipo_solicitud}
        />
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th>Cantidad</th>
              <th>
                <div>Línea</div>
              </th>
              <th>
                <div>Modelo</div>
              </th>
              <th>
                <div>Serie</div>
              </th>
              <th>
                <div>Precio Lista</div>
              </th>
              <th>
                <div>Descuento</div>
              </th>
              <th>
                <div>Valor Operación</div>
              </th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {stateVendidas.data === undefined ||
            stateVendidas.data === null ||
            stateVendidas.data.length === 0 ? (
              <tr>
                <td colSpan="9" style={{ textAlign: "initial" }}>
                  Sin unidades
                </td>
              </tr>
            ) : (
              stateVendidas.data.map((item) => (
                <tr key={item.id}>
                  <td>{item.cantidad}</td>
                  <td>{item.nuevo}</td>
                  <td>{item.modelo}</td>
                  <td style={{ textAlign: "center" }}>{item.serie}</td>
                  <td>{FormatMoney(item.precio)}</td>
                  <td>{FormatMoney(item.descuento)}</td>
                  <td>
                    {FormatMoney(
                      Number(item.precio) * Number(item.cantidad) -
                        Number(item.descuento)
                    )}
                  </td>
                  <td>
                    <CreateIcon onClick={() => openModal(item.registro)} />
                  </td>
                  <td>
                    <DeleteIcon onClick={() => EliminarRegistro(item)} />
                  </td>
                </tr>
              ))
            )}
          </tbody>
          {stateVendidas.data && stateVendidas.data.length > 0 && (
            <tfoot>
              <tr>
                <td>Total</td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  {FormatMoney(
                    stateVendidas.data.reduce(
                      (sum, item) => sum + Number(item.precio),
                      0
                    )
                  )}
                </td>
                <td>
                  {FormatMoney(
                    stateVendidas.data.reduce(
                      (sum, item) => sum + Number(item.descuento),
                      0
                    )
                  )}
                </td>
                <td>
                  {FormatMoney(
                    stateVendidas.data.reduce(
                      (sum, item) =>
                        sum +
                        (Number(item.precio) * Number(item.cantidad) -
                          Number(item.descuento)),
                      0
                    )
                  )}
                </td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          )}
        </table>
      </div>
    </Context.Provider>
  );
}

function ModalAgregar({ screen, setScreen, tipodesolicitud }) {
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [modelos, setModelos] = useState([]);
  const { state, setState } = useContext(Context);
  const closeModal = () => {
    setState({
      ...state,
      open: false,
      // registro: state.registro - 5858,
    });
  };
  const [unidades, setUnidades] = useState({
    nuevousado: "",
    modelo: "",
    serie: "",
    cantidad: "",
    precio: "",
    descuento: 0,
    total: "",
    descripcion: "",
    bnuevousado: false,
    bmodelo: false,
    bserie: false,
    bcantidad: false,
    bprecio: false,
    bdescuento: false,
    bdescripcion: false,
  });
  const onChange = (prop, value, sbool, smensaje) => {
    const sinComas = value.replace(/,/g, "");
    setUnidades({
      ...unidades,
      [prop]: sinComas,
      ["b" + prop]: false,
      ["m" + prop]: "",
    });
  };
  const onGuardar = () => {
    var result = ValPedidoUnidades(unidades);
    if (result.isValid === false) {
      Swal.fire(
        "PEDIDO DE MAQUINARIA",
        JSON.stringify(result.mensaje),
        "error"
      );
    } else {
      result.post.folio = state.folio;
      result.post.registro = state.registro;
      request
        .post("PedidoUnidades", result.post)
        .then(async () => {
          setLoader({ ...loader, mostrar: false });
          closeModal();
          var habScreen = Number(screen) >= 3 ? screen : 2;
          setScreen(habScreen);

          await Swal.fire({
            title: "PEDIDO DE MAQUINARIA",
            text: "Registro guardado con éxito",
            icon: "success",
            customClass: {
              container: "mi-superpoop",
            },
          });
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
        });
    }
  };
  useEffect(() => {
    if (
      state.registro !== undefined &&
      state.registro !== null &&
      Number(state.registro) > 0
    ) {
      request
        .get(
          `PedidoUnidades/GetByRegistro?folio=${state.folio}&registro=${state.registro}`
        )
        .then((result) => {
          setUnidades({
            ...unidades,
            nuevousado: result.nuevo,
            modelo: result.modelo,
            descripcion: result.descripcion,
            serie: result.serie,
            cantidad: result.cantidad,
            precio: result.precio,
            descuento: result.descuento,
          });
          document.getElementById("unidades_descuento").value = FormatMoney(
            result.descuento
          );
          document.getElementById("unidades_precio").value = FormatMoney(
            result.precio
          );
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire("PEDIDO DE MAQUINARIA", JSON.stringify(error), "error");
        });
    } else {
      setUnidades({
        nuevousado: "",
        modelo: "",
        serie: "",
        descripcion: "",
        cantidad: "",
        precio: "",
        descuento: 0,
        total: "",
        bnuevousado: false,
        bmodelo: false,
        bserie: false,
        bcantidad: false,
        bprecio: false,
        bdescuento: false,
        bdescripcion: false,
      });
    }
  }, [state.registro]);
  useEffect(() => {
    if (
      unidades.nuevousado === undefined ||
      unidades.nuevousado === null ||
      unidades.nuevousado === ""
    )
      return;
    setLoader({ ...loader, mostrar: true });
    request
      .get(`Modelos/Listado?linea=${unidades.nuevousado}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setModelos(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("PEDIDO UNIDADES", JSON.stringify(error), "error");
      });
  }, [unidades.nuevousado]);

  useEffect(() => {
    var cantidad =
      unidades.cantidad === undefined ||
      unidades.cantidad === null ||
      unidades.cantidad === ""
        ? 0
        : Number(unidades.cantidad);
    var precio =
      unidades.precio === undefined ||
      unidades.precio === null ||
      unidades.precio === ""
        ? 0
        : Number(unidades.precio);
    var descuento =
      unidades.descuento === undefined ||
      unidades.descuento === null ||
      unidades.descuento === ""
        ? 0
        : Number(unidades.descuento);
    setUnidades({
      ...unidades,
      total: FormatMoney(Number(cantidad) * Number(precio) - Number(descuento)),
    });
  }, [unidades.cantidad, unidades.precio, unidades.descuento]);
  const onFocus = (e) => {
    e.target.type = "number";
  };
  const onBlur = (e, prop) => {
    e.target.type = "text";
    e.target.value = FormatMoney(Number(unidades[prop]));
  };
  return (
    <Modal open={state.open}>
      <div className="dash-clientes-credito-crear-solicitud-modal">
        <div className="dash-clientes-credito-crear-detalle-financiamiento-modal-title">
          UNIDADES POR VENDER
        </div>
        <div className="plantilla-screen-efecto-a">
          <div className="plantilla-screen-efecto-bl"></div>
          <div className="plantilla-screen-efecto-circle"></div>
          <div className="plantilla-screen-efecto-br"></div>
        </div>
        <div className="dash-clientes-credito-crear-solicitud-modal-container">
          {tipodesolicitud === "J" ? (
            <TextField
              fullWidth
              size="small"
              label="Linea"
              variant="outlined"
              className="cel-1"
              select
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Agriculture fontSize="small" />
                  </InputAdornment>
                ),
              }}
              type="text"
              onChange={({ target }) => {
                setUnidades({
                  ...unidades,

                  nuevousado: target.value,
                  bnuevousado: false,
                });
              }}
              value={unidades.nuevousado}
            >
              <MenuItem value={"MQ"}>MAQUINARIA NUEVA</MenuItem>
              <MenuItem value={"UM"}>MAQUINARIA USADA</MenuItem>
              <MenuItem value={"MW"}>SISTEMAS DE RIEGO</MenuItem>
              <MenuItem value={"GE"}>GARANTIA EXTENDIDA</MenuItem>
              <MenuItem value={"PM"}>PAQUETE DE MANTENIMIENTO</MenuItem>
            </TextField>
          ) : (
            <TextField
              fullWidth
              size="small"
              label="Linea"
              variant="outlined"
              className="cel-1"
              select
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Agriculture fontSize="small" />
                  </InputAdornment>
                ),
              }}
              type="text"
              onChange={({ target }) => {
                setUnidades({
                  ...unidades,

                  nuevousado: target.value,
                  bnuevousado: false,
                });
              }}
              value={unidades.nuevousado}
            >
              <MenuItem value={"MQ"}>MAQUINARIA NUEVA</MenuItem>
              <MenuItem value={"UM"}>MAQUINARIA USADA</MenuItem>
              <MenuItem value={"MA"}>PRODUCTOS ALIADOS</MenuItem>
              <MenuItem value={"MW"}>SISTEMAS DE RIEGO</MenuItem>
              <MenuItem value={"SI"}>SOLUCIONES INTEGRALES</MenuItem>
              <MenuItem value={"GE"}>GARANTIA EXTENDIDA</MenuItem>
              <MenuItem value={"PM"}>PAQUETE DE MANTENIMIENTO</MenuItem>
            </TextField>
          )}

          <TextField
            size="small"
            id="modelo"
            label="Modelo"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Agriculture fontSize="small" />
                </InputAdornment>
              ),
            }}
            select
            className="pr-5 cel-2"
            value={unidades.modelo}
            onChange={({ target }) =>
              setUnidades({ ...unidades, modelo: target.value })
            }
            // options={modelos.map((option) => `${option.modelo}`)}
            // renderInput={(params) => <TextField {...params} label="Modelo" />}
          >
            {modelos.map((mld) => (
              <MenuItem value={mld.idmodelo}>{mld.modelo}</MenuItem>
            ))}
          </TextField>
          <TextField
            size="small"
            label="Descripción"
            variant="outlined"
            type="text"
            className="cel-3"
            error={unidades.bdescripcion}
            onChange={({ target }) => {
              ValTextAndNumber("descripcion", target.value, onChange, true, 100);
            }}
            disabled={Number(unidades.modelo) === 0 ? false : true}
            value={
              Number(unidades.modelo) === 0 && unidades.modelo !== ""
                ? unidades.descripcion
                : ""
            }
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ArticleIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            size="small"
            label="Serie"
            variant="outlined"
            type="text"
            className="cel-4"
            fullWidth
            error={state.bserie}
            onChange={({ target }) => {
              ValTextAndNumber("serie", target.value, onChange, true, 100);
            }}
            value={unidades.serie}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <VerticalSplitIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            className="pr-5 cel-5"
            size="small"
            label="Cantidad"
            variant="outlined"
            type="number"
            inputProps={{
              style: { textAlign: "right" },
            }}
            error={state.bcantidad}
            onChange={({ target }) => {
              ValOnlyNumber("cantidad", target.value, onChange, true, 10);
            }}
            value={unidades.cantidad}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Agriculture fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            id="unidades_precio"
            size="small"
            label="Precio de lista"
            variant="outlined"
            type="text"
            className="pr-5 cel-6"
            inputProps={{
              style: { textAlign: "right" },
            }}
            error={state.bprecio}
            // onFocus={onFocus}
            // onBlur={(e) => onBlur(e, "precio")}
            onChange={({ target }) => {
              ValOnlyNumber("precio", target.value, onChange, true, 30);
            }}
            onKeyUp={(input) => Moneda(input.target)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoneyIcon size="small" />
                </InputAdornment>
              ),
            }}
          ></TextField>

          <TextField
            className="pr-5 cel-7"
            size="small"
            id="unidades_descuento"
            label="Descuento"
            variant="outlined"
            type="text"
            inputProps={{
              style: { textAlign: "right" },
            }}
            error={state.bdescuento}
            // onFocus={onFocus}
            // onBlur={(e) => onBlur(e, "descuento")}
            onChange={({ target }) => {
              ValOnlyNumber("descuento", target.value, onChange, true, 30);
            }}
            onKeyUp={(input) => Moneda(input.target)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoneyIcon size="small" />
                </InputAdornment>
              ),
            }}
          ></TextField>
          <TextField
            className="cel-8"
            fullWidth
            size="small"
            label="Valor Operación"
            variant="outlined"
            disabled={true}
            type="text"
            inputProps={{
              style: { textAlign: "right" },
            }}
            value={unidades.total}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AttachMoneyIcon size="small" />
                </InputAdornment>
              ),
            }}
          ></TextField>
        </div>

        <div className="dash-clientes-credito-crear-solicitud-modal-button-container">
          <Button onClick={closeModal} variant="contained" color="error">
            Cerrar
          </Button>
          <Button variant="contained" onClick={() => onGuardar()}>
            Agregar
          </Button>
        </div>
      </div>
    </Modal>
  );
}
